import React, { Component } from 'react'
import {  Modal, Button } from 'react-bootstrap';
import { translate } from 'react-i18next';

class ErrorModal extends Component {
    constructor(props){
        super(props);
        this.state = {
            detail : props.errorMessage? props.errorMessage.detail :"Something went wrong!",
        }
    }
    componentWillReceiveProps(nextProps){
    if (nextProps.errorMessage !== this.props.errorMessage &&
         (nextProps.errorMessage !== null && nextProps.errorMessage !== undefined)) {
            const {detail} = nextProps.errorMessage;
            this.setState({detail : detail ? detail : nextProps.errorMessage})
        }
    }
    render() {
        const { t } = this.props;
        return (
            <Modal
                {...this.props}
                backdrop="static"
                bsSize="small"
                aria-labelledby="contained-modal-title-sm"
            >
                <Modal.Header closeButton bsClass="modal-header error-header">
                    <Modal.Title>{t('error')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.detail}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={()=>this.props.onHide()}>{t('close')}</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}
export default translate('translations')(ErrorModal);



// WEBPACK FOOTER //
// ./src/modal/util/ErrorModal.js